export class RequestDefaultsConfig {
    constructor(config) {
        this.setConfig(config);
    }
    setConfig(config) {
        if (config) {
            Object.entries(config).forEach(([key, value]) => {
                this[key] = value;
            });
        }
    }
}
export class RampConfig {
    constructor(options) {
        this.requestConfig = new RequestDefaultsConfig();
        if (options)
            this.setConfig(options);
    }
    setConfig(options) {
        Object.entries(options).forEach(([_key, value]) => {
            if (!value)
                return;
            this.requestConfig.setConfig(value);
        });
    }
}
